module.exports = __webpack_public_path__ + "img/bottomBg2.bd8cd389.png";